import locales from '../../../../../content.json';
import { PAYMENT_TARIFF } from '../../../../../types';
import { Environment } from '../../../../../types/environment';
import { getParameterFromURL } from '../../../../../utils/scripts/getParameterFromUrl';

let lang = window.navigator.language.slice(0, 2) || 'en';
const supportedLangs = ['en', 'ru', 'es', 'fr', 'de', 'pt', 'it', 'tr', 'pl', 'uk'];
if (!supportedLangs.includes(lang)) {
  lang = 'en';
}

const extraOptionsVariants = {
  mostPopularTitle: locales[lang].tariff_most_popular,
};

const durationVariants = {
  oneMonth: {
    title: locales[lang].chatUpsale_12,
    week: locales[lang].payment_text_66,
    perSecond: locales[lang].tariff_per_day,
  },
  threeMonth: {
    title: locales[lang].chatUpsale_13,
    week: locales[lang].payment_text_67,
    perSecond: locales[lang].tariff_per_day,
  },
};

const { mostPopularTitle } = extraOptionsVariants;
const { oneMonth, threeMonth } = durationVariants;

interface IProductIds {
  month?: number;
  threeMonths?: number;
}

type DefaultPrices = {
  month?: string | number;
  threeMonths?: string | number;
  defaultOldPrices?: string | number;
  productName?: string;
};

export function getPricesConfig(tariff: PAYMENT_TARIFF, environment = process.env.ENVIRONMENT) {
  let ids: IProductIds;
  let defaultPrices: DefaultPrices;
  let defaultPricesPerDay: DefaultPrices;
  let defaultPricesPerWeek: DefaultPrices;
  let defaultOldPrices: DefaultPrices;
  let productName: DefaultPrices;

  const subscrEU = getParameterFromURL('subscrEU');
  const subscrUK = getParameterFromURL('subscrUK');

  let subscriptionDev;
  let subscriptionProd;

  if (subscrEU) {
    subscriptionDev = 129;
    subscriptionProd = 124;
  } else if (subscrUK) {
    subscriptionDev = 128;
    subscriptionProd = 123;
  } else {
    subscriptionDev = 127;
    subscriptionProd = 122;
  }

  switch (tariff) {
    case PAYMENT_TARIFF.DEFAULT:
      ids = {
        // month: environment === Environment.prod ? 38 : 44,
        month: environment === Environment.prod ? subscriptionProd : subscriptionDev,
      };
      defaultPrices = {
        month: '19.99',
      };
      defaultPricesPerDay = {
        month: 0.99,
      };
      defaultPricesPerWeek = {
        month: 6.99,
      };
      defaultOldPrices = {
        month: '45.6',
      };
      productName = {
        month: 'everydoggy_1MONTH_29_99_USD_TRAINER_CHAT',
      };
      break;
    default:
      ids = {
        month: environment === Environment.prod ? 9 : 12,
        threeMonths: environment === Environment.prod ? 8 : 15,
      };
      defaultPrices = {
        month: '29.99',
        threeMonths: '39.99',
      };
      defaultPricesPerDay = {
        month: 0.99,
        threeMonths: 0.44,
      };
      defaultPricesPerWeek = {
        month: 7.0,
        threeMonths: 3.11,
      };
  }

  return {
    extraOptions: {
      mostPopularTitle: mostPopularTitle,
    },
    defaultDesign: {
      firstPriceConfig: {
        id: ids.month || 8,
        title: oneMonth.title,
        defaultPrice: defaultPrices.month,
        defaultPricePerDay: defaultPricesPerDay.month,
        defaultPricePerWeek: defaultPricesPerWeek.month || '6.99',
        defaultOldPrices: defaultOldPrices?.month || null,
        productName: productName?.month || '',
        perDay: oneMonth.perSecond,
      },
      secondPriceConfig: {
        id: ids.threeMonths || 10,
        title: threeMonth.title,
        defaultPrice: defaultPrices.threeMonths,
        defaultPricePerDay: defaultPricesPerDay.threeMonths,
        defaultPricePerWeek: defaultPricesPerWeek.threeMonths || '2.99',
        defaultOldPrices: defaultOldPrices?.threeMonths || null,
        productName: productName?.threeMonths || '',
        perDay: threeMonth.perSecond,
      },
    },
  };
}
